<template>
  <div class="common-box">
    <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="70px"
    >
      <search-form
        @search="handleSearch"
        @refresh="handleRefresh"
      >
        <div slot="content">
          <el-form-item label="部位名称：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.locationName"
              placeholder="请输入部位名称"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button v-if="hasRole['BYBWTJ']" size="mini" type="primary" class="plr28" @click="handleAdd">添加</el-button>
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="handleDelete"
          plain
          v-if="hasRole['BYBWSC']"
        >删除</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="exportLocation"
          plain
          class="plr28"
          v-if="hasRole['BYBWDC']"
        >导出</el-button>
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column show-overflow-tooltip prop="locationName" label="部位名称" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="otherDescription" label="其他说明" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" label="备注信息" width="200"></el-table-column>
      		<el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" v-if="hasRole['BYBWBJ']" type="text" @click="handleEdit(scope.row)">编辑</el-button>
              <div class="btn-divide" v-if="hasRole['BYBWBJ']"></div>
              <el-button size="mini" v-if="hasRole['BYBWSC']" type="text" @click="handleDeleteLocation(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-location
      v-if="addLocationVisible"
      @cancel="addLocationVisible = false"
      @confirm="handleAddLocationConfirm"
    ></add-location>
    <edit-location
      v-if="editLocationVisible"
      :editData="locationDetail"
      @cancel="editLocationVisible = false"
      @confirm="handleEditLocationConfirm"
    ></edit-location>
    <check-location
      v-if="checkLocationVisible"
      :editData="locationDetail"
      @cancel="checkLocationVisible = false"
    ></check-location>
  </div>
</template>

<script>

  import { getMaintainLocationList, deleteLocation, exportLocation } from '@/api/MaintenanceLocation'

  import AddLocation from './components/AddLocation'
  import EditLocation from './components/EditLocation'
  import CheckLocation from './components/CheckLocation'
  export default {
    name: 'MaintenanceLocation',
    components: {
      AddLocation,
      EditLocation,
      CheckLocation,
    },
    data() {
      return {
        form: {
          locationName: '',
        },
        tableLoading: false,
        list: [],
        multipleSelection: [],
        pageIndex: 1,
        pageSize: 50,
        total: 0,
        addLocationVisible: false,
        editLocationVisible: false,
        checkLocationVisible: false,
        checkDepartment: false,
        locationDetail: {}
      }
    },
    computed: {
      hasRole: function() {
        return this.$store.getters['common/promise/getRole'](this.$route.path);
      }
    },
    created() {
      this.getListData()
    },
    methods: {
      async getListData() {
       this.tableLoading = true
       const params = {
         pageIndex: this.pageIndex,
         pageSize: this.pageSize
       }
       for(let key in this.form) {
         if (this.form[key])
          params[key] = this.form[key]
       }
        const res = await getMaintainLocationList(params)
        if (res.code === 200) {
          this.total = res.data.total
          this.list = res.data.list
        }
        this.tableLoading = false
      },
      handleSearch() {
        this.pageIndex = 1
        this.getListData()
      },
      handleRefresh() {
        for(let key in this.form) {
          if (Array.isArray(this.form[key])) {
            this.form[key] = []
          } else {
            this.form[key] = ''
          }
        }
        this.pageIndex = 1
        this.getListData()
      },
      handleSearchListData() {
        this.pageIndex = 1
        this.getListData()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      handleDeleteLocation(row) {
        const idList = [row.id]
        this.deleteLocation(idList)
      },
      handleCheck(row) {
        this.locationDetail = row
        this.checkDepartment = true
      },
      handleEdit(row) {
        this.locationDetail = row
        this.editLocationVisible = true
      },
      handleDelete() {
        if (!this.multipleSelection.length) {
          this.$message.warning('请选择要删除的行')
          return
        }
        const idList = this.multipleSelection.map(item => item.id)
        this.deleteLocation(idList)
      },
      deleteLocation(idList) {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await deleteLocation({idList})
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getListData()
          }
        }).catch((err) => {
          console.log(err)
        })

      },
      handleAdd() {
        this.addLocationVisible = true
      },
      exportLocation() {
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for(let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }
        exportLocation(params)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getListData()
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.getListData()
      },
      handleAddLocationConfirm () {
        this.addLocationVisible = false
        this.pageIndex = 1
        this.getListData()
      },
      handleEditLocationConfirm () {
        this.editLocationVisible = false
        this.getListData()
      },

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/MaintenanceLocation/MaintenanceLocation.vue